import { Header } from "@radix-ui/react-accordion";
import { skeletonize } from "../../../helpers/skeletonize";
import { Body } from "../../body/Body";
import { StatusChipSkeleton } from "../../status-chip/StatusChip.Skeleton";
import { MinusIcon } from "../icons/minus-icon/MinusIcon";
import { PlusIcon } from "../icons/plus-icon/PlusIcon";
import {
  Item as AccordionItemBase,
  Content,
  ItemNumberContainer,
  SkeletonItemProps,
  TitlesContainer,
  ToggleIconContainer,
  Trigger,
  padNumber,
} from "./AccordionItem.Parts";

const BodySkeleton = skeletonize(Body);

export const AccordionItemSkeleton = ({
  title,
  subtitle,
  status,
  numbered,
  index,
  showBorder = true,
}: SkeletonItemProps) => (
  <AccordionItemBase
    disabled={true}
    value={`skeleton-item-${index}`}
    key={`skeleton-item-${index}`}
    $showBorder={showBorder}
  >
    <Header>
      <Trigger tabIndex={-1} disabled={true}>
        {numbered && index && (
          <ItemNumberContainer>
            <BodySkeleton>{padNumber(index)}</BodySkeleton>
          </ItemNumberContainer>
        )}
        <TitlesContainer>
          <BodySkeleton variant="normal-strong">{title}</BodySkeleton>
          {subtitle && <BodySkeleton variant="small">{subtitle}</BodySkeleton>}
        </TitlesContainer>
        {status && <StatusChipSkeleton label={status} />}
        <ToggleIconContainer tabIndex={-1} aria-hidden="false">
          <PlusIcon />
          <MinusIcon />
        </ToggleIconContainer>
      </Trigger>
    </Header>
    <Content />
  </AccordionItemBase>
);
